<div class="container-fluid p-0 m-0" style="overflow: hidden">
  <router-outlet></router-outlet>
</div>
